import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './styles/fonts.css'
import './styles/globals.css'
import { initTheme } from './lib/theme'

// Scroll-reveal hidden states are gated on .lp-js so no-JS visitors see
// every section (marketing layer in globals.css).
document.documentElement.classList.add('lp-js')
initTheme()

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
